import React from 'react';
import { Link } from 'react-router-dom';
import '../estilo.css';

export default class Contato extends React.Component {
  render() {
    return (
      <div id="contact" className="container-fluid bg-grey contact-container">
        <div className="text-center" style={{ maxWidth: '900px', margin: '0 auto 40px' }}>
          <h2 className="contact-title">Contato</h2>
          <h3 style={{ color: '#ece7f6', marginBottom: '12px' }}>
            Precisa de ajuda para começar ou tirar dúvidas sobre os robôs?
          </h3>
          <p style={{ color: '#d7d0e8', fontSize: '16px', lineHeight: 1.7 }}>
            Fale com a equipe da Quantum Trades para suporte sobre planos, instalação,
            licenciamento, configuração inicial e contratação dos robôs.
          </p>
        </div>

        <div className="row" style={{ maxWidth: '1100px', margin: '0 auto' }}>
          <div className="col-sm-4">
            <div
              style={{
                background: 'rgba(255,255,255,0.06)',
                border: '1px solid rgba(255,255,255,0.10)',
                borderRadius: '12px',
                padding: '24px 20px',
                minHeight: '250px',
                marginBottom: '20px',
              }}
            >
              <h3 style={{ color: '#42a89c', marginTop: 0 }}>Atendimento direto</h3>

              <p style={{ color: '#ece7f6', marginBottom: '16px' }}>
                Entre em contato para suporte comercial e operacional.
              </p>

              <p>
                <span className="bi bi-whatsapp contact-icon"></span>
                <a
                  href="https://wa.me/5542984241307"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-link"
                >
                  WhatsApp: (42) 98424-1307
                </a>
              </p>

              <p>
                <span className="bi bi-mailbox contact-icon"></span>
                <a
                  href="mailto:contato@quantumtrades.com.br"
                  className="contact-link"
                >
                  contato@quantumtrades.com.br
                </a>
              </p>

              <p style={{ color: '#d7d0e8', marginTop: '18px', marginBottom: 0 }}>
                Atendimento a clientes do Brasil e exterior.
              </p>
            </div>
          </div>

          <div className="col-sm-4">
            <div
              style={{
                background: 'rgba(255,255,255,0.06)',
                border: '1px solid rgba(255,255,255,0.10)',
                borderRadius: '12px',
                padding: '24px 20px',
                minHeight: '250px',
                marginBottom: '20px',
              }}
            >
              <h3 style={{ color: '#42a89c', marginTop: 0 }}>Canais oficiais</h3>

              <p style={{ color: '#ece7f6', marginBottom: '16px' }}>
                Acompanhe novidades, conteúdos e comunidade.
              </p>

              <p>
                <span className="bi bi-youtube contact-icon"></span>
                <a
                  href="https://www.youtube.com/@QuantumTradesBR"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-link"
                >
                  YouTube: @QuantumTradesBR
                </a>
              </p>

              <p>
                <span className="bi bi-telegram contact-icon"></span>
                <a
                  href="https://t.me/QuantumTradesBr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-link"
                >
                  Grupo no Telegram
                </a>
              </p>

              <p style={{ color: '#d7d0e8', marginTop: '18px', marginBottom: 0 }}>
                Conteúdo, atualizações e comunicação com a comunidade.
              </p>
            </div>
          </div>

          <div className="col-sm-4">
            <div
              style={{
                background: 'rgba(255,255,255,0.06)',
                border: '1px solid rgba(255,255,255,0.10)',
                borderRadius: '12px',
                padding: '24px 20px',
                minHeight: '250px',
                marginBottom: '20px',
              }}
            >
              <h3 style={{ color: '#42a89c', marginTop: 0 }}>Próximo passo</h3>

              <p style={{ color: '#ece7f6', marginBottom: '16px' }}>
                Já sabe qual plano deseja contratar?
              </p>

              <p style={{ color: '#d7d0e8', lineHeight: 1.7 }}>
                Monte sua simulação, escolha os robôs, selecione o tier ideal e siga para o
                cadastro da sua conta.
              </p>

              <div style={{ marginTop: '18px' }}>
                <Link to="/planos" className="btn btn-primary btn-lg" style={{ width: '100%' }}>
                  Ver planos
                </Link>
              </div>

              <div style={{ marginTop: '10px' }}>
                <Link to="/cadastro" className="btn btn-default btn-lg" style={{ width: '100%' }}>
                  Ir para cadastro
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}